import type { MealType } from '@libs/data-access/queries'
import {
  IconWrap,
  AccountingBillIcon,
  MealBenefitIcon,
  MealVoucherIcon,
  BasketBonusIcon
} from '@libs/ui/ds'
import Immutable from 'immutable'
import type { ReactNode } from 'react'
import React from 'react'

export const IR = 'IR'
export const AN = 'AN'
export const TR = 'TR'
export const PP = 'PP'

export type MealTypeItem = {
  id: MealType
  name: string
  icon?: ReactNode
  label: string
}

type MealTypeIterable = Immutable.Map<string, MealTypeItem>

/**
 * @deprecated mapping, use MealTypes insted
 */

export const MealTypesLegacy: MealTypeIterable = Immutable.OrderedMap({
  IR: {
    id: IR,
    name: 'models.mealTypes.ir',
    label: 'models.mealTypes.irLabel',
    icon: <IconWrap icon={<AccountingBillIcon />} />
  },
  AN: {
    id: AN,
    name: 'models.mealTypes.an',
    label: 'models.mealTypes.anLabel',
    icon: <IconWrap icon={<MealBenefitIcon />} />
  },
  TR: {
    id: TR,
    name: 'models.mealTypes.tr',
    label: 'models.mealTypes.trLabel',
    icon: <IconWrap icon={<MealVoucherIcon />} />
  },
  PP: {
    id: PP,
    name: 'models.mealTypes.pp',
    label: 'models.mealTypes.ppLabel',
    icon: <IconWrap icon={<BasketBonusIcon />} />
  }
})

export const MealTypes: MealTypeItem[] = [
  {
    id: IR,
    name: 'models.mealTypes.ir',
    label: 'models.mealTypes.irLabel',
    icon: <AccountingBillIcon />
  },
  {
    id: AN,
    name: 'models.mealTypes.an',
    label: 'models.mealTypes.anLabel',
    icon: <MealBenefitIcon />
  },
  {
    id: TR,
    name: 'models.mealTypes.tr',
    label: 'models.mealTypes.trLabel',
    icon: <MealVoucherIcon />
  },
  {
    id: PP,
    name: 'models.mealTypes.pp',
    label: 'models.mealTypes.ppLabel',
    icon: <BasketBonusIcon />
  }
]
